export default{
  "home": {},
  "about": {},
  "disclaimer": {},
  "legal3": {},
  "character": {
    "p2": "女流雀士",
    "p3": "一色清美",
    "p4": "閃耀的一色使",
    "p5": "CV 小倉唯",
    "p6": "從小和父母一起旅居海外，由於父母非常喜歡麻將，便在家庭麻將中學會了麻將的玩法。正式開始打麻將後，因為超乎常人的運氣，在牌局上總是所向披靡。 為了親身體驗不一樣的麻將樂趣，懷揣著成為職業雀士和進軍世界大賽的夢想，隻身一人來到了強手雲集的《麻雀一番街》。",
    "p7": "三宅環奈",
    "p8": "絕對雀感夢想家",
    "p9": "CV 新井里美",
    "p10": "童年時收到了最喜歡的鄰居姐姐送的一副兒童麻將，從而喜歡上了麻將，但是因為只有一個人，所以經常一個人分飾多個角色，自己和自己打麻將時很喜歡把這些故事寫下來，在網上發表後一躍成名。\n從論壇上知道了《麻雀一番街》，懷著看看麻將世界的想法來到了這裡。出於小說家的敏感，她發現一番街每位雀士背後都有神奇的故事，喜歡將故事添油加醋地編寫進自己的作品中。",
    "p11": "東方凪",
    "p12": "會心一擊的淑女",
    "p13": "CV 小倉唯",
    "p14": "家族開設了當地最大的雀莊，但由於家人忙於經營，感到被忽視的她因此曾一度非常討厭麻將。直到有一天偶然在網絡上看到了父親作為職業雀士的比賽，被父親的光芒所感染，夢想成為像父親一樣的職業雀士。\n開始認真打麻將的她，展示了驚人的天賦，很快成為了當地的知名雀士。然而，近期的她卻陷入持續地惡調中，為了找到對抗惡調的方法，她在《麻雀一番街》的雀莊不斷地嘗試著。",
    "p15": "五十嵐紗子",
    "p16": "深度讀牌曼哈頓",
    "p17": "CV 長谷川玲奈",
    "p18": "小時候因為父母不會說話，於是從小學會了從人的動作、表情猜測其意圖，非常擅長讀心；孤獨的她被電視上麻將牌的聲音所吸引，從此想要把麻將作為自己的終身事業。\n喜歡喝酒，在一番街經營這一個交換秘密的酒館，由於知道每個雀士的秘密，有傳聞紗子就是一番街那個「神秘的存在」，即一番雀莊和《麻雀一番街》的背後操縱者。但真相是什麼，誰也不知道。",
    "p19": "九鬼蓮心",
    "p20": "鬼氣滿滿狂戰士",
    "p21": "CV 新井里美",
    "p22": "上學時期，因為偷偷去玩街機，學會了打麻將。天生喜歡與人打賭，連吃拉麵都喜歡與人打賭是單數時長吃完還是雙數時長吃完。\n長大後因為想要看看不同的地方，參加了無國界醫護組織。回國後成為了自由護士，因為認識某個醫生，追隨其來到一番市的醫院，自此過上了上班時安靜無存在感，下班後瘋狂蹦迪和參與地下賭博的生活。後來覺得賭博無趣，想要挑戰不同的牌手，來到了《麻雀一番街》。",
    "p23": "天海汐月",
    "p24": "數據流求道者",
    "p25": "CV 長谷川玲奈",
    "p26": "是學校裡的學生會長。小時候，數學老師的爺爺認為學習麻將有利於培養思維，於是她接觸了麻將，非常注重手順和數據。後來她進入瓶頸期，和前輩一起分析牌譜時發現，有時候自己的一些失誤反倒影響了別人的判斷，於是逐漸形成了反讀牌打法。為了更好地練習，作為學生會長的她選擇了業餘時間在雀莊打工。\n她感受到數據流麻將難以駕馭，為了突破數據流麻將的極限來到《麻雀一番街》，想結識更多高手。她很喜歡七對子，因為可以靈活運用讀山、讀人、騙筋等戰術。",
    "p27": "男子雀士",
    "p28": "天宮健一",
    "p29": "傾奇王子",
    "p30": "CV 森嶋秀太",
    "p31": "說話比較輕浮，有時比較中二，經常掛在嘴邊的臺詞是「聽牌即立、單騎王道、NOMI是必殺技」。學生時代受同學的影響學會了打麻將，後沉迷網絡麻將，在《麻雀一番街》網絡遊戲中有著不俗的成績。\n因為好奇一番街背後那個「神秘的存在」究竟是誰，前往一番街打著零工。在一些蛛絲馬跡下，將懷疑的對象指向了酒館女老闆五十嵐紗子，於是展開了一系列鬥智鬥勇的故事，也在女老闆的引導下，致力於成為一名職業雀士。",
    "p32": "雀丸",
    "p33": "四川的副露大師",
    "p34": "CV 森嶋秀太",
    "p35": "四川的副露大師，來自中國四川的熊貓。精通中國的各類麻將，尤其是四川麻將。來到一番街是想要和日本牌手們進行交流。受到川麻的影響，屬於超攻擊型選手，也希望在日麻中多學習學習防守之道；日語不是特別好，最近沉迷日麻。",
    "p36": "五月女百合香",
    "p37": "天使的旋律",
    "p38": "CV 石川由依",
    "p39": "和比自己大5歲的哥哥相依為命。雖然看不見，但是喜歡一切彩色的裝飾物，最喜歡聽周圍的人說色彩。\n從小患有罕見眼疾，無法看見任何東西，大部分時間都在醫院度過。她的父母為了治療她嘗試了所有的方法，但是都沒有取得成果，最終不得已放棄治療、並且在她七歲時離開。留下她和哥哥相依為命。\n內心因為看不見、沒朋友而痛苦，但是因為不希望哥哥擔心，所以在哥哥和外人面前永遠笑意盈盈，只有獨自一人時才會悄悄哭泣。\n為了鍛鍊妹妹的觸覺，哥哥讓百合香從識別麻將花紋開始學習麻將，第一次觸摸到麻將子是一索，從那時起百合香就有了一種奇妙的感覺，她似乎在心裡看見了這些花紋，於是喜歡上打麻將。\n因為看不見，她的聽覺異常的好，同時具備了強大的音樂天賦，她的音樂裡總是有一股溫暖激勵人心的力量。同時她也在醫院裡當兼職鋼琴家，經常給深陷病痛的人彈奏鋼琴，也因為去醫院，認識了九鬼，從而認識主角們。",
    "p40": "赤羽雅典娜",
    "p41": "絕對正義女武神",
    "p42": "CV 石川由依",
    "p43": "作為員警守護一番街的治安。上司經常提醒她打扮得要更像員警一點，但她認為這些表面的事情並不重要，於是屢教不改。武力很強，整條街的小混混都特別害怕她。\n父親是FBI的警官，出任務有時會帶上她，讓她知曉了很多人間疾苦，也看到了各種各樣的罪惡。她雖然看起來強硬粗暴，灑脫不羈，內心卻是一個理想主義者，願望是拯救每一個失足的少年少女。\n出任務受傷時被九鬼蓮心醫治過，自稱擔心她進行違法治療行為，因此和她經常發生衝突，但其實很關心九鬼蓮心，生怕她狂氣的性格惹出什麼危險，還會悄悄尾隨到她蹦迪的場所去觀察情況。後來尾隨九鬼蓮心來了雀莊，馬上喜歡上打麻將。",
    "p44": "夏海真凜",
    "p45": "百獣女王",
    "p46": "CV 直田姫奈 ",
    "p47": "一番街有名的美髮師，善於製作各種神奇的造型。表面看著非常的清純，吸引著很多人慕名前往，但是實際性格卻截然相反，她更喜歡操控一切。表面是因為她愛美而從事美髮事業，但是實際是因為人們美髮時通常無法隨意擺動頭部，她很喜歡這種掌控感，所以沉迷美髮事業。\n喜歡一切創意的事情，打麻將時也充滿了想像力，經常打出神奇一打，打牌和本人一樣好看。也因為打牌攻勢兇猛、下手果斷，所以以老虎自居。聽說當胡到大牌時，腦門也會出現隱約的“王”字。掌控能力特別強，非常善於控分。\n因為其他雀士喜歡來她這裡美髮而認識。因為感覺可以掌控很多人，卻無法掌控五月女直哉，而對其有好感。面對真正喜歡的人，實際是個十足的戀愛腦。",
    "p48": "五月女直哉",
    "p49": "烈焰之拳",
    "p50": "CV 浪川大輔",
    "p51": "五月女百合香的哥哥。妹妹從小患了罕見的眼部疾病，無法看見任何東西。但是直哉堅信可以治好妹妹的疾病。\n兩人在很小的時候就被父母遺棄，為了維持生計，做過各種各樣的工作。為了給妹妹治病，為了賺更多的錢，他開始打拳擊。\n本質溫柔內斂，不善於表達，因為吃過很多苦，面對妹妹以外的事情都很冷漠、疏離。平時比賽時會非常地兇狠、但面對妹妹時卻非常地溫柔，僅有的笑容也是給妹妹的。妹妹儘管內心很痛苦，但是在哥哥面前一直都是以樂觀堅強的樣子示人，反倒是哥哥，內心深處其實有脆弱的部分存在。\n為了培養妹妹的觸覺，教妹妹練習觸摸麻將，自己也因此喜歡上打麻將。\n在打拳時只是孤注一擲地戰鬥，但打麻將時卻有時間冷靜下來，探索自己的內心。",
    "p52": "深瀨愛麗絲",
    "p53": "戰術女神",
    "p54": "CV 沼倉愛美",
    "p55": "巨型財團深瀬的大小姐，不僅作為家族門面、優雅地參與各種宴會和社交場合，也用自己的實力與頭腦支援財團的商業戰爭。生來聰穎的深瀨愛麗絲對自己的頭腦充滿自信，她認為憑藉自己就能做到幾乎任何事情。 \n梅妮亞——深瀨愛麗絲的秘密特工——在天和市的一番街工作，最近似乎有了什麼新的發現，讓原本在西大陸留學的愛麗絲開始對這座城市和麻雀競技產生興趣。僅用一週時間，她便成為了職業雀士，並隨即加入三途川Industry。她的外號因此多了一個：沉迷麻雀的深瀨家大小姐。 \n深瀨愛麗絲喜歡思考和運用各種戰略和戰術，打麻將的時候也喜歡構築各種策略，將自己的打法稱為“愛麗絲的絕妙戰術”。她的目標是能在一番街達到2.1的平順，目前離目標還比較遙遠。 \n即使看起來如此優秀，但深瀨愛麗絲其實也有不擅長的事情，那就是料理：明明按著配方來做，卻總是做出黑暗料理……但儘管如此，她依然持續不斷地在嘗試。因為深瀨愛麗絲不能有任何短板，任何方面都必須十全十美！",
    "p56": "梅妮亞",
    "p57": "沉默的執行者",
    "p58": "CV 悠木碧",
    "p59": "在一番百貨的服裝店擔任店員，身材姣好，看上去有些呆呆的，不善言詞，講話讓人感覺有點冷漠。 \n她的真實身份是深瀨愛麗絲派來一番街的諜報員，訓練有素，會暗自記下客人的資訊，將內容篩查後，選出自己覺得有意義的情報，回報給深瀨愛麗絲。除此以外，梅妮亞經常參與一番街內的麻雀對戰，這能讓她得以接近一些平時接觸不到的人，從而獲取更多情報。 \n常常忍氣吞聲，會讓人產生她是一名弱質女流的錯覺，但傳聞她曾徒手將鬧事的八阪會十名成員扔出店外。無論別人如何詢問這件事，梅妮亞都堅持那是謠言；究竟這件事是真是假，可能就只有幾名當事人知道了。 \n梅妮亞是流落街頭的時候被主人撿到的，主人是財團的大小姐，非常任性。大小姐看出了梅妮亞那木訥雙眸中連野狗都敬而遠之的冷光，但她依舊向梅妮亞伸出了手。在看到冷光消失的一刻，大小姐知道，一種契約在兩人間結成。",
    "p60": "AU.RO.RA",
    "p61": "永生的吸血姬",
    "p62": "CV 大西沙織",
    "p63": "看上去只有16歲、可實際已經活了很多很多年，在某些方面散發出一些只有老人家才會有的時代感，像是「吸血鬼」的這個稱呼。 \n作為血族中的稀有種類「日行者」，她可以在白天出現；但是，因為不是純種的日行者，需要借助特殊的呼吸器才可以行動，但這同時也能讓她避免自己失控，不至於傷害其他人。出於同樣的原因，每到白天，她都會用綁帶將雙手束縛住。 \n因為不是純種的關係，她患上了罕見的失憶症——會在每天白天的時候忘記自己是誰，然後在晚上恢復。早在很多年前便學會了麻將，這也是她活到現在唯一的愛好。 \n由於吸血鬼都有數數字的強迫症，以及聽聞打麻將對於治療失憶有好處，她每到夜晚都會去東方雀莊來上幾局，樂此不疲的數數字牌。為了克制自己吸血，她總是用打有赤的麻將的方式來轉移注意力。她希望透過自己的各種努力，成為可以在陽光下自由行走、不用吸血的吸血鬼。",
    "p64": "不二一氣",
    "p65": "半吊子占卜師",
    "p66": "CV 杉山紀彰",
    "p67": "自稱是三宅環奈小說中的人物，因為不滿意環奈的創作進度，為了敲打她而出現在現實的世界中。在三宅環奈一本名為《一氣通貫的勇敢少年》中，主角兔兔次郎的形象和性格確實與不二一気極為相似，因此這個自稱一度讓一些不明真相的小朋友信以為真。\n實際上只是小說主角的原型人物、三宅環奈的遠房表弟，也是她的忠實書粉。最初不二一気並不知道三宅小兔是誰，直到一次偶然的機會，他在三宅家中、無意間看見了散落在角落的小說手稿。明白真相之後，他便追隨環奈的腳步，轉學來了天和市。\n為了扮演好兔兔次郎這個角色，不二一気經常會在一番街街頭拉住各種各樣的人，美其名曰占卜他們的命運，然後胡說一些泛泛而談的話。在打牌前，他有時也會占卜自己的運勢，張口就說「我接下來5個半莊的成績是11221」之類的話。而在他所有的預言中，一半的情況什麼也不會發生，另一半卻分毫不差，令人感到相當地不可思議。",
    "p68": "白羽飛鳥",
    "p69": "魔女的黃金瞳",
    "p70": "CV 內田真禮",
    "p71": "神秘的中二病少女，總是佩戴著一根標識有No.001字樣的手環，自稱異色的右瞳擁有看透一切的能力，是隸屬Dawn命運騎士戰隊的王牌雀士。\n白羽飛鳥首戰即成名，作為一名在賽前無人關注的新人雀士，卻在天下一番賞第一場終局前不利的情況下，扔出了四暗刻單騎大四喜加字一色的恐怖爆彈，瞬間讓全世界觀看這場對局的觀眾陷入瘋狂。\n在此之後，白羽飛鳥展現出了她對牌桌的恐怖統治力。她無疑是當年天下一番賞中最受矚目的黑馬，Dawn命運騎士的奪冠賠率一度逼平帝皇。\n然而令人沒想到的是，決賽當天，她在一家動漫屋內翻看新刊雜誌時不慎睡著，直到比賽結束兩小時後才醒來。白羽飛鳥的首次天下一番賞之旅就這樣讓人哭笑不得地結束了。\n當記者事後採訪她時，她捂住自己心臟，緊皺眉頭，十分痛苦地說：「這就是身為命運騎士而不得不背負的東西，但我絕不會屈服，終有一日，我要站在那傲慢的神明面前，告訴祂：即使身為凡人，也能成為世界最強！」",
    "p72": "原道雪",
    "p73": "無雙的劍士",
    "p74": "CV 由加奈",
    "p75": "道雪是一名孤兒，被道場的師傅撿到，從記事起便開始隨著師傅學習劍術。\n可能是師傅不大靠譜的原因，道雪自幼年時，便早熟地驚人。自號“劍雀雙絕”的師傅每天的工作，除了指點學員練習外，就只剩下拉著道雪湊局打牌，道場的主持工作早早交給了道雪打理。\n逐漸附近的人們都知道：新陰道場出了個很了不起的女劍士，不僅劍術高超、樣貌端莊，為人也謙和有禮；只是，和她師傅一樣，除了練劍打牌，好像就沒有什麼其他的愛好了。\n道雪本來以為這種白天練劍、晚上打牌的日子，會這麼一直持續下去，直到18歲的那天，她準備打掃師傅的房間時，卻看到一張寫著：“你出師啦！道場交你了！小雪，好好幹！”的紙條；從那天之後，她就再也沒見過師傅的身影……。\n一頭霧水的道雪，在某日路過街邊商店時，震驚地在電視中看見了一張熟悉的面孔，當時，螢幕裡正轉播著一場重要的麻雀比賽的畫面。從此，“天下一番賞”這個詞映入了她的眼簾……",
    "p76": "音無郁子",
    "p77": "社恐系主播",
    "p78": "CV 由加奈",
    "p79": "專攻網路麻雀的天才虛擬主播。就讀於私立貴族中學秀櫻學園的音無郁子，是熠熠星海中一顆黯淡的六等星，藉由向父母死纏爛打、與自身拼命學習，終於考入這所學園的她，卻發現自己的人生並未如設想中那般、自動地變得光彩照人。她的陰暗氣場與生俱來，令她似乎無論在哪裡，都只能扮演一棵背景中默默無名的樹。\n然而，這棵無人關注的樹，卻在網路上有著她的一席之地：在一層薄而堅實的螢幕背後，作為虛擬主播「音速奈奈子」的郁子，搖身一變成了積極開朗、熱情活潑的陽光角色。她以時下最熱門的網路麻雀為自己的活動領域，短時間內迅速爬分到天梯五百強之列。在與多名職業雀士交手而不落下風後，一個關於神秘網麻高手的傳說開始瘋傳。\n在虛擬世界中受到追捧的郁子並不滿足，她開始將目光投向了現實的職業賽場：在那裡出名的話，是否會變得更受歡迎呢？被這樣的想法所推動，郁子小心翼翼地踏上了職業雀士之路。",
    "p80": "榎宮澪",
    "p81": "黑白世界的孤者",
    "p82": "CV 悠木碧",
    "p83": "來自么九街的野犬，出生後被母親拋棄在陰暗混亂的么九街。原本有著一頭漂亮的黑髮，但被看不慣的混小孩潑了一桶白色油漆，嘲笑「野犬」不配擁有這種東西。這次事故讓她視力受損，無助的澪回家看著鏡子裡的自己，為了銘記這份屈辱，決定從此使頭髮變得黑白分明。\n一個經常出沒於地下雀莊的大叔收養了澪。大叔發現她在麻將上天賦異稟，擁有超乎常人的觀察力、和計算能力，於是教給了她很多的技巧，並讓她進入地下雀莊參加比賽、打假牌。澪小小年紀就開始在地下雀莊活躍，收入頗豐，雖然她知道大叔只是把她當做賺錢工具利用，但還是很感謝大叔給了她一個住所。直到有一天，大叔在她賭博落敗的時候想拿她作為抵押，讓她心灰意冷，終於決定逃離了么九街。\n輾轉來到一番街的澪，偶然被東方雀莊招為店員，她的天賦開始嶄露頭角。在東方雀莊的幫助下，成功註冊為職業雀士後，她的人生由此翻開了一頁新的篇章。",
    "p84": "小倉奏",
    "p85": "時尚潮流的追隨者",
    "p86": "CV 直田姬奈",
    "p87": "時尚潮流的追隨者。在秀櫻學園那些循規蹈矩的好學生們看來，小倉奏是一種來自異次元的另類生物。他們不能理解她存在於這裡的意義，也無從進入她的世界中，只能從一些流言蜚語，打聽到她的一些蛛絲馬跡，進而在腦海中形成一幅“不良少女”的扭曲畫像。\n許多關於小倉奏的傳說，就連她本人聽了也會大吃一驚，但她很少去刨根究底，因為時尚的潮流總能輕易地拉走她的注意力。所謂的潮流，是那些會一閃即逝的東西；對小倉奏而言，沒有什麼比追逐這種短暫的光彩，更加重要且緊急的事情了——即便這可能讓她不得不違反某些死板的校規。她並不在乎，就像彗星不會在乎地球的引力一樣。\n星辰戰隊很快就發現了這樣一名光彩照人的女高中生，向她發出邀請，她欣然接受。將自己打牌與和牌的照片傳到SNS上，看著點讚和評論數飛漲，是她的樂趣之一。但她也因此生出一個煩惱，那就是她和出好牌的次數並不太多，拍出的照片不夠“閃亮”。該如何提升雀力，成為了她當下的首要課題。",
    "p88": "不破真晝",
    "p89": "追逐勝利的王女",
    "p90": "CV 夏吉優子",
    "p91": "追逐勝利的無畏王女，凜然純粹的高嶺之花。 \n作為中央雀院前任院長的孫女，不破真晝自十五歲時第一次以職業雀士身份登上競技賽場以來便吸引了整個麻雀領域的目光。她的職業生涯首秀毫無疑問是驚豔的，首次參加比賽即表現出驚人的沉穩和應變能力，勢如破竹地拿下了個人賽第一名。同年，不破真晝隨帝皇俱樂部出戰天下一番賞，在決賽中與傳奇雀士涼城九郎艱難鏖戰並取得勝利，幫助隊伍擊敗三途Industry奪得冠軍。此戰之後，不破真晝聞名天下，而涼城九郎與式部神人隨後的接連退役則昭示著這場新王加冕的史詩徹底拉開帷幕。次年，不破真晝與帝皇俱樂部再次出征天下一番賞，在戰勝異軍突起的Dawn命運騎士並成功衛冕後，史無前例的三連冠已經近在這名天才少女的眼前。 \n無數記者從不破真晝身上嗅到了商機，然而在麻雀之外， 她的生活近乎一片空白。無論記者們怎樣探查，也絲毫發掘不出她的任何業餘愛好、緋聞八卦亦或爭議言論。她的眼中似乎只有麻雀，除此之外再無其他。",
    "p92": "犬飼陽菜",
    "p93": "秩序的代理人",
    "p94": "CV 夏吉優子",
    "p95": "秩序的代理人，微笑著的溫柔惡魔。\n很少有人知道，如今更多以「雀丘中學理事長」身份為人所熟知的犬飼陽菜，在中學畢業前曾被中央雀院內部評定為S級預備錄取生之一。在犬飼陽菜畢業典禮結束後的當天，她從郵箱裡收到了來自中央雀院的祝賀與邀請。無需任何考核、免取一切學費、並承諾一筆只需完成輕鬆條件即可獲得的可觀助學獎金，這是中央雀院自信滿滿地向她拋出的籌碼。\n幾乎沒有麻雀愛好者能拒絕中央雀院的如此優待，這是曾經身為麻雀天才的犬飼陽菜，經歷過的、令人豔羨的人生，然而，最終她卻選擇了一條更加平凡、或許也更加艱難的道路——為重振日漸衰落的雀丘中學而努力。為此，她選擇了向天和大學發出入學申請，攻讀管理學、與教育學兩項專業，並在畢業後毅然回到母校就職。\n如今，犬飼陽菜加入雀丘戰隊，重新開啟了她的麻雀生涯；她在出道後一系列比賽中的精采發揮，又再度喚起了天和雀壇對曾經的、那位天才少女的回憶。",
    "p96": "立花薰",
    "p97": "治愈系偶像",
    "p98": "CV 上村祐翔",
    "p99": "溫柔陽光的後進型偶像。當星辰少年三期團出演他們的第一場live時，立花薰只是恰巧陪同身為粉絲的友人在台下遠遠地觀看。然而，就是那一次偶然、而驚豔的邂逅，改變了立花薰此後的人生軌跡。\n立花薰出身於古典音樂世家，父母倆人成名已久，哥哥則是備受矚目的小提琴新星，同樣擁有不俗音樂天賦的立花薰在一番思考後，最終選擇了一條不同於家人的路——成為一名偶像。\n在此之前毫無基礎的立花薰，在極短時間內便練就了高超的舞蹈技巧，近乎完美的歌喉，則使任一歌曲都能在他口中被演繹為天籟之聲。恰在此時，原本的三期團員之一的千葉春暉因故退出，正申請加入四期預備役的立花薰被製作人選中，接替了前者的位置。至此，立花薰開始在偶像之路上閃耀光芒。\n作為團中年紀最小的成員，立花薰卻以溫柔可靠而聞名，令人如沐春風的氣質一直延續到了牌桌之上——在和牌時，他甚至會故意降低飜數以免傷害他人。對他而言，人與人之間聯繫的紐帶，要遠比輸贏更加重要。",
    "p100": "鈺燭",
    "p101": "古玉之龍姬",
    "p102": "CV 田村由加莉",
    "p103": "從神秘玉石中出現的、不可思議的女孩，長著奇異的角和尾巴，對一切都呈現出茫然無知的模樣，唯獨十分肯定地將隊長認作自己的親人。 \n由隊長和她共同創造的“鈺燭”這個名字，由幻化出她的玉和從她口中說出的“燭”組合而來。或許是因為稍顯拗口，本人更喜歡“小鈺”這個稱呼。 \n鑒於鈺燭對隊長表現出的親暱和不捨，一番街的員警赤羽雅典娜建議暫時將她交由隊長監管，並承諾警局方面會提供相應的支援。在隊長答應之前，小鈺先露出了開心的表情。 \n在赤羽雅典娜對鈺燭的來歷、和身份進行調查的期間，隊長承擔起了監護人的職責。只不過，小鈺成長和變化的速度，似乎遠比隊長想像中來得更快……",
    "p104": "萌木原葵",
    "p105": "嶺上的神使",
    "p106": "CV 長繩麻理亞",
    "p107": "嶺上的神使，一發的巫女。現就讀於南風私立小學的萌木原葵，在不久前剛剛創下了一番會自成立以來，註冊年齡最小的職業雀士記錄。\n迄今為止，萌木原葵參加過的職業比賽尚且不多、也並未展現出明顯的打牌風格；但是，她總是會以立直一發自摸、或嶺上開花的方式和牌，彷彿看透了牌山一般地不可思議。\n除去日常的學習生活、和麻雀職業比賽之外，葵大多時候，都在嶺上區的稻荷神社中，作為巫女活動。在週末、或節假日，來到神社參拜的人們，常常能夠看到一個嬌小的身影坐在臺階上，無所事事般地發著呆，卻又在他們分神的刹那中消失不見，宛如傳說中的稻荷神使一般，幻惑而奇異。",
    "p108": "風間雫",
    "p109": "自由街頭",
    "p110": "CV 長繩麻理亞",
    "p111": "重視收益的激進派。對風間雫而言，玩弄驚險已成為她的日常習慣。人們永遠也猜不透，在她那副清冷沉靜的外表下，每時每刻都在醞釀著怎樣瘋狂的想法。\n諸如踩著滑板，從一處天臺、飛躍至另一處天臺，只為用競技子彈在對方首領的腦門上開一個洞；打掉存量更多的牌，立直聽地獄單騎，而不考慮這張牌是否可能被山吞；投資時選擇並不被看好的股票或公司，以獲得它們在觸底反彈之後的最大回報……風間雫總是不斷地，將自己投身於險境，然後用華麗的姿態，將勝利的果實攬入懷中。\n風間雫的瘋狂行徑，與她的平靜外表，總是形成鮮明的反差；或許，在做出那些危險動作之前，她早已計算好了一切。\n又或者……她根本就是個瘋子。",
    "p112": "艾爾茜",
    "p113": "贖罪修女",
    "p114": "CV 雨宮天",
    "p115": "以心為眼，以觀靈魂，蒙眼的異國修女艾爾茜，全名為艾爾斯佩思·卡文迪什。 \n艾爾茜出生於奧爾比昂的林登黛爾郡，自醫科大學畢業後，她以志願者身份加入了聯合國人道救援小組，深入東大陸藍藻戰場對當地難民實施人道主義援助。 \n半年後，戰爭平息，她並沒有返回自己的家鄉，也沒有再繼續自己的醫療事業，而是選擇來到天和市，於北風街的聖主大教堂接受洗禮，成為了一名修女。 \n正是從那時起，她蒙上了自己的眼睛，拒絕再用它們去觀察這個世界。 \n不過這並未影響她成為一名職業雀士，即便不需要報牌輔助裝置，她也能對牌桌上的局勢瞭若指掌，並常常打出切中要害的一打。眼前的黑暗似乎並未令她陷入迷茫，反而使她看得更加清晰。",
    "p116": "如月璃紗",
    "p117": "鬼斬少女",
    "p118": "CV 雨宮天",
    "p119": "自極東轉學來到天和市的神秘少女，受人矚目的清楚系模特。 \n從踏入秀櫻學園校門的那一刻起，如月璃紗便成為了該校暗網論壇匿名版上的熱點人物。入學後不久，在一名女老師的熱情邀請下，璃紗加入美術社，成為常駐人體寫生模特，原本冷清的美術社因此在一夜之間成為熱門社團。另一邊，隨著新一期《星辰時尚》的發行，有人發現在其封面上赫然印著身著時尚裝束的璃紗的照片。很快，星辰俱樂部也正式宣佈了如月璃紗的加入。 \n作為一名高中生，如月璃紗的人生在別人看來幾乎是如同乘上了火箭一般飛速騰躍。然而關於她的種種事蹟卻始終圍繞著一層神秘的霧靄：她總是會在黃昏時刻消失，不知道家住哪裡，似乎從來沒有交過朋友，甚至連靠近她的人都會感到渾身惡寒……",
    "p120": "冷泉繪芽子",
    "p121": "超絕可愛機械兔",
    "p122": "CV 咲咲木瞳",
    "p123": "天才程式師少女，面無表情的“機械兔”。 \n在成為雀士以前，冷泉繪芽子曾作為高科技產品研發企業天宮集團中最年輕的天才程式師而聞名世界。在同齡人尚且為學校裡的數學題而苦惱的年紀，她卻已在世界最前沿的科技專案中成為了主力研發團隊中的一員。 \n幾年後，冷泉繪芽子被天宮集團派往天和市，與DAWN集團旗下的永恆生命製藥公司展開專案合作。由於專案的高度保密性，外界並不清楚冷泉繪芽子工作的具體內容是什麼，但兩大組織的強強聯手依然引來了不少好奇與關注。 \n在業餘時間，冷泉繪芽子也入鄉隨俗地開始以雀士身份進行活動，這使她逐漸從被天才神話所編織的面紗後走出，來到公眾的面前。然而她隨後展現出的個性，卻令所有人都大跌眼鏡……",
    "p124": "森流歌",
    "p125": "惡魔的手眼",
    "p126": "CV 八卷安奈",
    "p127": "來自高地共和國薔薇之劍部隊的軍人，目前正以休假的名義在天和市活動，充滿科技感的機械右臂令人印象深刻。 \n加入Dawn命運騎士戰隊後，森流歌於聯賽中展現出了驚人的實力。因其狠辣兇險、擅長針對弱點發起追擊的雀風，在雀士和觀眾間有“惡魔的手眼”之稱。 \n由於喜歡在對局中毫不隱晦地觀察對手，森流歌時常讓與她同場競技的雀士產生巨大的精神壓力。在收到多次投訴與警告後，森流歌道歉並進行了收斂。儘管如此，她依舊在“最不想遇到的對手”榜單中名列前茅。"
  },
  "news": {
    "p2": "全部",
    "p3": "遊戲公告",
    "p4": "維護資訊",
    "p5": "更新情報",
    "p6": "活動資訊",
    "p7": "活動「SUMMER LIVE」即將上線！",
    "p8": "《麻雀一番街》夏日派對馬上要開始了！",
    "p9": " \n在整個七月，一番街將舉辦一場盛大的夏日活動「SUMMER LIVE」，\n新雀士、新造型、還有新舊雀士的人氣投票對決！\n快加入《麻雀一番街》的夏日狂歡活動吧！一起來清涼一夏！ ",
    "p10": "【SUMMER LIVE活動】 \n■活動時間到7月29日(五) 22:59 （UTC+8）",
    "p11": "■新雀士-新造型",
    "p12": "■泳裝造型上線！",
    "p13": "■新舊雀士雀士直播人氣投票對決！\n活動期間，一色清美，三宅環奈，五月女百合香，赤羽雅典娜四大主播將會現身直播間，粉絲們記得給自己喜歡的主播送禮加油哦！\n※完成對局即可獲得給主播送禮加油的禮物，根據送禮次數可以獲得各種神秘道具獎勵！\n\n■首儲雙倍重置！\n為慶祝「SUMMER LIVE」活動的舉辦，遊戲將於更新後開啟“首儲雙倍重置”的活動。重置後，商店內一番券的所有額度，都有一次“首儲雙倍”的機會。\n※更新後每個額度都可以享受一次首儲雙倍，隊長們可以多次獲取雙倍體驗哦！\n■商店將上架全新禮包！\n禮包內包含更多限定道具哦~",
    "p14": "■「麻雀一番街」下載地址",
    "p15": "・iOS: {link}",
    "p16": "・Android: {link}",
    "p17": "・PC（Win）： {link}",
    "p18": "■關於遊戲的最新情報，可通過以下渠道了解。",
    "p19": "■ 有任何想知道的事、或需要協助的話，請通過客服信箱聯繫我們。",
    "p20": "活動「燃魂擂台」即將上線！",
    "p21": "9月26日，大型活動【燃魂擂臺】和兩名新角色即將加入一番街！                                                                          \n眾多豐富活動獎勵在等待著你！還有新雀士卡池和限定造型復刻哦！",
    "p22": "■【燃魂擂臺—地下拳王戰】活動 \n活動時間：9月26日更新後—10月15日22:59 (UTC+8) \n參與活動可以獲得限定稱號、頭像框、桌布、牌背等眾多豐富活動獎勵！",
    "p23": "■新雀士：夏海真凜、五月女直哉 \n限時UP卡池時間：9月26日更新後—10月15日22:59 (UTC+8)",
    "p24": "■隊長集結令活動 \n歡迎新老玩家在集結時間上線，感受一番街如今的魅力！ \n活動時間：9月26日",
    "p25": "■雀士限定造型復刻！ \n為了慶祝Steam版的發佈，將會在遊戲內商店限時售賣以下雀士限定造型！ \n◆東方凪・兔女郎 \n◆天海汐月・甜點娘 \n售賣時間：9月26日維護後～10月15日22:59（UTC+8）",
    "p26": "・Steam: {link}",
    "p27": "關於App Store新政策下的價格調整通知",
    "p30": "因App Store將於10月5日起實行新的價格及稅率政策調整，麻雀一番街將對全平台（iOS/Android/PC/Steam/Apk）的商品價格進行調整及更新。\n",
    "p31": "有關商品價格的具體調整，請通過下圖確認：",
    "p32": "注：調整後部分商品價格會有小幅下降",
    "p33": "商品價格調整日期：2022年10月5日（週三）",
    "p34": "【注意事項】",
    "p35": "・商品價格調整後~2022年10月18日22:59(UTC+8)，除了各選項的首儲2倍福利之外，進行二次儲值時也將享受額外20%的儲值福利。",
    "p36": "・在商品價格調整前後，可能會發生遊戲內價格、與各商店收取價格不一致的現象，請以購買確認畫面的價格標記為準。",
    "p37": "・根據使用的設備、及環境的不同，商品價格調整的顯示時間可能會有延遲的情況。請大家諒解並等待更新完成。",
    "p38": "・商品價格調整前得到的遊戲內容，在價格調整後也可以繼續正常使用。",
    "p39": "・PC版和Apk版沒有60一番券的購買選項。",
    "p40": "・iOS版和Android版價格調整前的部分商品價格不一致。（調整後將統一價格）",
    "p43": "「實況主聖誕大作戰」邀請函",
    "p44": "值此聖誕節來臨之際，《麻雀一番街》2.0也即將正式上線。\n為了慶祝《麻雀一番街》2.0版本上線，我們將於遊戲內舉辦一場《麻雀一番街》的全球實況主大賽！\n\n在此次比賽中，您將有機會與我們的官方大使：瑞原明奈pro、松本吉弘pro及千羽黑乃、鴨神にゅう、白雪レイド等全球100多名Vtuber以及ML選手仲林圭pro等一起同場競技。\n詳情請通過圖片了解："
  },
  "tour": {
    "p2": "比賽",
    "p3": "《麻雀一番街》玩家自辦比賽活動",
    "p4": "想玩一些不同的規則、或是和朋友來場激烈的競賽嗎？",
    "p5": "《麻雀一番街》的自建賽功能更好用了！\n現在辦比賽還有加碼額外的福利，快來試試吧！",
    "p6": "報名時間：\n6/23(四) ~ 7/22(五)",
    "p7": "報名方式：填寫表單，提供相關的資訊。*",
    "p8": "表單：{link}",
    "p9": "通過審核福利：\n①《麻雀一番街》遊戲內公告和社交平台曝光\n②《麻雀一番街》會提供一定程度的贊助**\n\n*  如果通過了審核，《麻雀一番街》團隊會聯繫您、商談進一步事宜\n** 贊助幅度主要根據主辦經歷、比賽規模、及賽程安排決定",
    "p10": "【官方賽事通知】天下第一雀鬥會",
    "p11": "麻雀一番街官方賽事「天下第一雀鬥會」開辦啦！\n\n在麻雀一番街、四人模式(下稱四麻)段位達到七段以上，即可參加！\n\n7月24日（週一）~7月26日（週三）每晚18點~23點（UTC+8，下同），在預賽房間進行賽事，預選決出本次賽事前16名，7月27日（週四）晚18點~21點在半決賽房間進行16進4的半決賽，7月28日（週五）晚18點~21點在決賽房間進行決賽並決出首屆「天下第一雀鬥會」年度總冠軍。決賽將會全程由職業雀士實況轉播、並進行解說。\n\n【參賽資格】\n截止到2023年7月20日（週四）23:00 ，四麻段位在七段~天下一番的玩家。\n\n【參賽方法】\n在開賽期間，滿足參賽資格玩家，可以透過以下對應自建賽ID搜尋、進入對戰：\n・預賽自建賽ID：6597939\n・半決賽自建賽ID：3220100\n・決賽自建賽ID：8973769\n\n【賽事競技規則】\n・四人麻將\n・半莊戰\n・長考時間：5+20秒\n・初始點數25000點・返點30000（無Top賞）\n・1位必要點數：30000（有西入、最終局首位超過3萬點時結束）\n・順位點：+30、+10、-10、-30\n・赤寶牌3張、有一發、裡寶牌、槓寶牌\n・可食斷、可後付\n・有中途流局（九種九牌、四風連打、四槓散了、三家和了、四家立直）\n・有聽牌連莊\n・有擊飛\n・最終局親家首位時、按和牌終局、聽牌終局進行\n・點數相同時，按東一局起家座次，離親家近者獲得前位的名次\n・賽事主辦方保留對比賽規則、和遊戲內容的最終解釋權\n\n【預選賽制】\n・預賽開賽時間內，符合本屆賽事參賽資格的玩家，可進入官方指定的大會室內、進行隨機匹配對戰。按連續5場對局的合計最高分進行排名。最終取排名前16名的玩家晉級半決賽。(在開賽時間內可進行任意次數對局，按所有對局中連續5場最高分成績進行統計)\n・預賽時間：2023年7月24日（週一）～7月26日（週三）毎晚18點~23點\n\n【半決賽賽制】\n・半決賽開賽時間內，本屆賽事16強進入官方指定的大會室進行比賽。半決賽會分成4桌，各自進行連續4場的四麻半莊戰對局（同一桌內，相同對手，隨機座次）。最終各桌4場對局合計最高分者晉級決賽。\n・16進4，各桌勝者晉級決賽\n・半決賽時間：2023年7月27日（週四）18點~21點\n\n【決賽賽制】\n・決賽開賽時間內，本屆賽事4強進入官方指定的大會室進行比賽。決賽進行連續4場的四麻半莊戰對局。根據最終4場比賽的合計分數，決出本屆賽事年度總冠軍。\n・決賽時間：2023年7月28日（週五）18點~21點\n・決賽將會全程由職業雀士實況轉播、並進行解說。\n\n【關於作弊行為】\n・比賽過程中禁止任何作弊行為，一經發現，即取消參賽資格，且永久禁止參加後續麻雀一番街的任何官方賽事。此外，作弊者所有對局成績無效，但對局結果會被保留。\n・本屆賽事的裁判，將由麻雀一番街營運團隊、及日本職業雀士團隊擔任。針對比賽中被監測到的任何不正當行為、及來自玩家的舉報，我們都會進行確認、並嚴格處理。\n\n【關於遲到、缺席行為】\n・預賽晉級16強玩家可在【7月26日（週三）23:00】之前聯繫官方郵箱{link}，告知我們您無法參加半決賽的原因，我們在確認後將會將您的晉級資格順延至排行榜後一位玩家。\n・半決賽及決賽，如無事前聯絡，在開賽後【5分鐘】過後依舊沒有進入對戰大會室並準備的，如果無法取得聯繫，將自動喪失參賽資格，並由賽事運營人員代打。賽事營運人員會以獲勝為目標替代缺席者進行對局，但營運人員的成績不會被進行統計。\n\n【獎品】\n・冠軍：實體冠軍獎盃 x1、月吉祥物（180天）、抽卡券 x50、價值50,000日元禮品卡、限定稱號「雀闘天下」一年使用權\n・亞軍：月吉祥物（30天）、抽卡券 x30、價值30,000日元禮品卡\n・季軍：月吉祥物（30天）、抽卡券 x20、價值20,000日元禮品卡\n・殿軍：月吉祥物（30天）、抽卡券 x10、價值10,000日元禮品卡\n・5～16名：月吉祥物（30天）、抽卡券 x5\n・役滿賞：在本屆賽事對局中，每和出一次役滿，將可額外獲得抽卡券x1"
  },
  "special": {
    "p2": "福利",
    "p3": "【貼圖】天宮健一貼圖發佈",
    "p4": "天宮健一（CV：森嶋秀太） ",
    "p5": "【貼圖】雀丸貼圖發佈",
    "p6": "雀丸（CV：森嶋秀太）",
    "p7": "【貼圖】五十嵐紗子貼圖發佈",
    "p8": "五十嵐紗子（CV：長谷川玲奈）",
    "p9": "【貼圖】天海汐月貼圖發佈",
    "p10": "天海汐月（CV：長谷川玲奈）",
    "p11": "【貼圖】九鬼蓮心貼圖發佈",
    "p12": "九鬼蓮心（CV：新井里美）",
    "p13": "【貼圖】一色清美貼圖發佈",
    "p14": "一色清美（CV：新井里美）",
    "p15": "【貼圖】三宅環奈貼圖發佈",
    "p16": "三宅環奈（CV：新井里美）",
    "p17": "【貼圖】東方凪貼圖發佈",
    "p18": "東方凪（CV：小倉唯）",
    "p19": "親愛的隊長：",
    "p20": "這裡是麻雀一番街活動委員會！\n為了紀念新雀士登場，我們也一併公開了相關的貼圖！",
    "p21": "登場角色：",
    "p22": "歡迎多加利用！",
    "p23": "▼保存方法",
    "p24": "【手機】長按貼圖",
    "p25": "【PC】點擊貼圖下載",
    "p26": "【全部下載】點擊{here}",
    "p27": "▼貼圖",
    "p28": "這裡",
    "p29": "【貼圖】赤羽雅典娜貼圖發佈",
    "p30": "赤羽雅典娜（CV：石川由依）",
    "p31": "【貼圖】五月女百合香貼圖發佈",
    "p32": "五月女百合香（CV：石川由依）",
    "p33": "【頭像】角色頭像發佈",
    "p34": "這裡是麻雀一番街活動委員會！\n為了紀念麻雀一番街上線半週年，我們公開一組角色頭像！\n歡迎多加利用！\n",
    "p35": "【橫幅】Twitter橫幅發佈",
    "p36": "這裡是麻雀一番街活動委員會！\n為了紀念麻雀一番街上線半週年，我們公開一組Twitter橫幅！歡迎多加利用！",
    "p37": "▼頭像",
    "p38": "【手機】長按頭像",
    "p39": "【PC】點擊頭像下載",
    "p40": "【手機】長按橫幅",
    "p41": "【PC】點擊橫幅下載",
    "p42": "▼橫幅",
    "p43": "【貼圖】夏海真凜貼圖發佈",
    "p44": "夏海真凜(CV:直田姫奈)",
    "p45": "【貼圖】五月女直哉貼圖發佈",
    "p46": "五月女直哉(CV:浪川大輔)",
    "p47": "【貼圖】深瀨愛麗絲貼圖發佈",
    "p48": "深瀨愛麗絲(CV:沼倉愛美)",
    "p49": "【貼圖】梅妮亞貼圖發佈",
    "p50": "梅妮亞(CV:悠木碧)",
    "p51": "【貼圖】AU.RO.RA貼圖發佈",
    "p52": "AU.RO.RA(CV:大西沙織)",
    "p53": "【貼圖】白羽飛鳥貼圖發佈",
    "p54": "【貼圖】不二一氣貼圖發佈",
    "p55": "白羽飛鳥（CV：内田真礼）",
    "p56": "不二一氣（CV：杉山紀彰）",
    "p57": "【貼圖】原道雪貼圖發佈",
    "p58": "原道雪（CV： 由加奈）",
    "p59": "【貼圖】音無郁子貼圖發佈",
    "p60": "音無郁子（CV：由加奈）",
    "p61": "【貼圖】榎宮澪貼圖發佈",
    "p62": "榎宮澪（CV： 悠木碧）",
    "p63": "【貼圖】小倉奏貼圖發佈",
    "p64": "小倉奏（CV： 直田姬奈）",
    "p65": "【貼圖】不破真晝貼圖發佈",
    "p66": "不破真晝（CV： 夏吉優子）",
    "p67": "【貼圖】犬飼陽菜貼圖發佈",
    "p68": "犬飼陽菜（CV： 夏吉優子）",
    "p69": "【貼圖】立花薰貼圖發佈",
    "p70": "立花薰（CV： 上村祐翔）",
    "p71": "【貼圖】鈺燭貼圖發佈",
    "p72": "鈺燭（CV： 田村由加莉）",
    "p73": "【貼圖】麻雀一番街 x 告別回憶 聯動",
    "p74": "這裡是麻雀一番街活動委員會！\n麻雀一番街 × 告別回憶系列 聯動的\n貼圖限時公開至3/31(日)！\n請按自己的需要保存及使用！\n\n歡迎多加利用！",
    "p75": "【頭像】麻雀一番街 x 告別回憶 聯動",
    "p76": "這裡是麻雀一番街活動委員會！\n麻雀一番街 × 告別回憶系列 聯動的\n頭像限時公開至3/31(日)！\n請按自己的需要保存及使用！\n\n歡迎多加利用！",
    "p77": "【貼圖】萌木原葵貼圖發佈",
    "p78": "萌木原葵（CV：長繩麻理亞）",
    "p79": "【貼圖】風間雫貼圖發佈",
    "p80": "風間雫（CV：長繩麻理亞）",
    "p81": "【貼圖】艾爾茜貼圖發佈",
    "p82": "艾爾茜（CV：雨宮天）",
    "p83": "【貼圖】「麻雀一番街 × 槍彈辯駁」聯動",
    "p84": "這裡是麻雀一番街活動委員會！\n麻雀一番街 × 槍彈辯駁 聯動的\n貼圖限時公開至7/30 22:59(UTC+8)！\n請按自己的需要保存及使用！\n\n歡迎多加利用！",
    "p85": "【貼圖】如月璃紗貼圖發佈",
    "p86": "如月璃紗（CV：雨宮天）",
    "p87": "【貼圖】森流歌貼圖發佈",
    "p88": "森流歌（CV：八卷安奈）",
    "p100": "這裡是麻雀一番街活動委員會！\n為了紀念新雀士登場，我們也一併公開了相關的貼圖！"
  },
  "verify": {
    "p2": "牌山生成公開",
    "p3": "牌山生成方法公開：",
    "p4": "1、遊戲中採用純隨機的方式生成牌山，無任何特意安排，為了確認公平性，我們公佈遊戲中有關牌山生成的相關代碼：",
    "p5": "2、為了保證隨機生成的代碼在遊戲過程中也沒有進行任何篡改，我們在遊戲中引入SHA-256碼：",
    "p6": "1）遊戲中每次配牌生成的牌山都會有對應的SHA-256碼，玩家可以在每小局對局時點擊左上角的場次說明處查看該局的SHA-256碼；\n2）對局結束後，玩家可以在牌譜中查看該局的牌山編碼，將牌山編碼在任意SHA-256碼網站上輸入，可以獲得一個SHA-256碼，可以將對局中的SHA-256碼與此SHA-256碼進行校驗，相同則意味著我們沒有在遊戲過程中篡改牌山。",
    "p7": "3）牌山編碼規則：",
    "p8": "①萬子牌：用m表示萬子牌，1~9m即對應1~9萬，紅5萬用0m表示；\n②筒子牌：用p表示筒子牌，1~9p即對應1~9筒，紅5筒用0p表示；\n③條子牌：用s表示條子牌，1~9s即對應1~9條，紅5條用0s表示；\n④字牌：用z表示字牌，1~7z分別對應著東、南、西、北、白、發、中。\n如1萬2筒3索中，即編碼顯示為1m2p3s7z。\n牌山編碼是根據牌山的順序進行的，即從前往後，從上面的牌到下面的牌。",
    "p9": "註：",
    "p10": "1、為什麼我們要選擇公開代碼？",
    "p11": "1）我們希望給玩家創造一個更加公平、公正的日麻競技平臺，讓玩家可以更好地用實力進行切磋。發牌是影響公平性的重要元素之一，故我們一直採用的是隨機發牌的方式，現在希望通過公開的方式讓玩家看見我們的堅持；\n2）公開代碼是為了向玩家表明我們每一局發牌都是隨機的，沒有對玩家的手牌做任何不公平的配置，而加上SHA256碼是為了保證我們不僅開始時是隨機的，中途也是沒有進行篡改的；\n3）後續我們也會動態持續公佈所有的歷史發牌記錄（包括但不限於歷史每個起手牌的花色占比概率、牌結構占比概率等），但是由於我們人員較少，現階段還有很多功能要製作，所以暫時無法滿足，敬請諒解；\n4）如果玩家有什麼更好的做法，也可以與我們聯繫。客服信箱：riichicitysupport@mahjong-jp.com",
    "p12": "2、為什麼我們選擇SHA256碼而不是MD5碼？",
    "p13": "眾所周知，MD5碼是一種被廣泛使用的公開的加密解密技術的標準演算法，它的單向性、唯一性、混沌性已經非常好的保證了牌山無法篡改了。我們內部在校驗代碼的一致性時也經常會用到MD5演算法。\n\n那麼為什麼要選擇SHA256碼而不是MD5碼呢？\n因為與SHA256碼相比，MD5碼相對較容易破解（雖然也要嘗試很多很多次），SHA256碼相對安全性更高；另外MD5碼相對容易碰撞（碰撞的意思是可能會相同），雖然概率極低，但是我們也希望儘量避免發生。\n總之任何影響用戶權益的地方，我們都希望能夠做得更好。",
    "p14": "3、為什麼我們選擇公開一整副牌的編碼而不是除去起手牌後的牌山編碼？",
    "p15": "這是為了保證我們也沒有對起手牌做任何配置，不會刻意給玩家發好壞牌。"
  },
  "streamer": {
    "p2": "實況主專區",
    "p3": "歡迎各位實況主來到《麻雀一番街》，期待看到您的精彩放送！",
    "p4": "▼實況素材下載",
    "p5": "《麻雀一番街》為您準備了一些素材，",
    "p6": "可以在《麻雀一番街》相關的實況、和創作中自由使用。",
    "p7": "下載請戳【這裡】",
    "p8": "▼聯絡我們",
    "p9": "如果有以下的想法，歡迎通過email聯絡我們，團隊會在收到來信後的第一時間回覆！",
    "p10": "想要在《麻雀一番街》舉辦比賽、希望商談贊助。",
    "p11": "想要成為《麻雀一番街》的官方合作實況主。",
    "p12": "有其他對《麻雀一番街》的意見、建議、期待想提供、或有其他希望商談的事宜。",
    "p13": "聯絡信箱：",
    "p14": "《麻雀一番街》感謝您的支持、也會儘量提供您最好的協助。祝遊戲愉快！",
    "p15": "riichicitysupport@mahjong-jp.com",
    "p16": "常用素材：下載請戳【這裡】",
    "p17": "星辰LIVE活動素材：下載請戳【這裡】",
    "p18": "貪婪遊輪活動素材：下載請戳【這裡】",
    "p19": "極速狂飆活動素材：下載請戳【這裡】",
    "p20": "緋色盛夏活動素材：下載請戳【這裡】"
  },
  "riichicitystore": {
    "p2": "加載中......"
  },
  "survey_bg": {
    "p2": "为了寻找拥有",
    "p3": "“超高中级”",
    "p4": " ",
    "p5": "才能的人，",
    "p6": "我们——希望峰学园，\n发明了“超高中级的测试”。\n现在，我们诚邀你参与这份测试。",
    "p7": "你拥有怎样的才能呢？",
    "p8": "开始测试",
    "p9": "重测",
    "p10": "分享结果",
    "p11": "超高中级诊断",
    "p12": "超高中级的",
    "p13": "点击继续",
    "p14": "语言选择",
    "p15": "开始测试",
    "p16": "重新测试",
    "p17": "保存结果",
    "p18": "分享结果",
    "p19": "麻雀一番街官网",
    "p20": "保存成功",
    "p21": "分享成功",
    "p22": "更多",
    "p23": "返回",
    "p24": "微信",
    "p25": "微博",
    "p26": "百度贴吧",
    "p27": "前往测试",
    "p28": "麻雀一番街 x 枪弹辩驳的联动活动",
    "p30": "联动活动【超高中级诊断】分享奖励",
    "p31": "亲爱的队长，感谢你参加联动活动【超高中级诊断】！请接收以下奖励！",
    "p32": "奖励已经通过邮件发送给队长啦，请到游戏内查收~",
    "p36": "我在麻雀一番街 x 枪弹辩驳的联动活动测试中，结果为",
    "p37": "！快点击链接试试吧！",
    "p41": "麻雀一番街活动",
    "p42": "我在麻雀一番街活动测试中，结果为",
    "p43": "！快点击链接试试吧！",
    "p46": "超高中级的测试",
    "p47": "一番街枪弹辩驳联动",
    "p48": "【麻雀一番街×枪弹辩驳联动】  <超高中级测试>",
    "p51": "活动已结束~",
    "p52": "将于",
    "p53": "秒后自动跳转至",
    "p54": "「麻雀一番街」",
    "p55": "官网"
  },
  "survey_question": {
    "p2": "你认为努力和运气，哪一个更重要？",
    "p3": "努力",
    "p4": "运气",
    "p5": "平时你更喜欢待在哪？",
    "p6": "户外",
    "p7": "室内",
    "p8": "你更喜欢独处还是聚会？",
    "p9": "独处",
    "p10": "聚会",
    "p11": "你更喜欢推理还是想象？",
    "p12": "推理",
    "p13": "想象",
    "p14": "你更喜欢山岳还是大海？",
    "p15": "山岳",
    "p16": "大海",
    "p17": "你崇尚速度还是力量？",
    "p18": "速度",
    "p19": "力量",
    "p20": "你更喜欢倾诉还是倾听？",
    "p21": "倾诉",
    "p22": "倾听",
    "p23": "不清楚",
    "p24": "你喜欢二次元还是三次元？",
    "p25": "二次元",
    "p26": "三次元",
    "p27": "你觉得自己的运气怎么样？",
    "p28": "强运",
    "p29": "普通",
    "p30": "你身上哪一面更加突出？",
    "p31": "理性",
    "p32": "感性",
    "p33": "你更喜欢已知还是未知",
    "p34": "已知",
    "p35": "未知",
    "p36": "你更愿意做以下哪种行为？",
    "p37": "打麻将",
    "p38": "看书",
    "p39": "你更喜欢安静还是热闹？",
    "p40": "安静",
    "p41": "热闹",
    "p42": "外部环境发生变化时，大部分时候你……",
    "p43": "保持冷静",
    "p44": "情绪激昂",
    "p45": "你觉得自己是一个怎样的人？",
    "p46": "乐观的人",
    "p47": "悲观的人",
    "p48": "没错...这样的结局果然搞错了什么吧。\n就这样结束的话，绝望地无聊不是吗?",
    "p49": "绝望",
    "p50": "非常绝望"
  },
  "survey_result": {
    "p2": "超高中级的格斗家",
    "p3": "你如山岳般镇定，刻苦的训练使你拥有超群的武艺。\n你会在山间的大树和清风间看见自然的奥义，\n从此一拳一脚契合大道，实现天人合一。",
    "p4": "超高中级的游泳选手",
    "p5": "你如水一样温柔，又如阳光般令人温暖。\n尽管你时常孤独地训练，\n但是亲切的性格使你在集体活动中也如鱼得水。\n请你相信，总有一片大海知道你付出了多少汗水和眼泪。",
    "p6": "超高中级的飙车族",
    "p7": "你目标坚定，永不退缩，拥有绝对的男子汉气概。\n加速吧！狂风和闪电会成为你的翅膀！\n但是，要注意交通安全哦~",
    "p8": "超高中级的棒球选手",
    "p9": "你活泼热情，总能和同伴打成一片。\n出色的腕力和动态视力使你投出的球如导弹般威力无穷。\n如果坚持训练，也许有一天能成为天下闻名的职业选手哦。",
    "p10": "超高中级的风纪委员",
    "p11": "你热爱集体，公正无私。\n你深知维护秩序远比破坏秩序更艰难。\n要珍惜你严肃的表情下藏着的那颗温柔的心。",
    "p12": "超高中级的程序员",
    "p13": "你不善言辞，但思维敏捷，逻辑清晰。\n你的代码就是你思想的分身，\n向千万个人诉说着你闪闪发光的才能。\n做你喜欢的事就好，喜欢永远比被喜欢重要。",
    "p14": "超高中级的？？？",
    "p15": "你身上谜团重重……\n仅凭这次测试似乎无法判断出你的才能。\n说不定保持神秘就是你的才能。",
    "p16": "超高中级的同人作家",
    "p17": "你拥有出色的想象力和对二次元的爱！\n请拿起笔，把你的想象力和爱传递给他人吧。\n这是何等伟大的才能！",
    "p18": "超高中级的文学少女",
    "p19": "你是一位才华出众的少女，\n将来一定能写出畅销的恋爱小说！！！\n什么？你说你不是少女？\n那可真是抱歉，不小心就激动起来了……",
    "p20": "超高中级的赌徒",
    "p21": "你表情背后暗含的深意无人知晓。\n与你对赌是一种不幸，因为从一开始结局就已经注定。\n世上没有逢赌必赢的技巧，只有逢赌必赢的人。",
    "p22": "超高中级的名门公子",
    "p23": "你理智得近乎冷酷。即使生来拥有常人难以企及的优势，\n也不会因此沾沾自喜。\n欲戴王冠，必承其重，\n在名为王道的荆棘之路上，不要回头。",
    "p24": "超高中级的占卜师",
    "p25": "你是一个浪漫而与世无争的人。\n你的脑海里藏着另外一片美丽的星空。\n快帮朋友占卜吧，尽管他们对你的准确性保持怀疑！",
    "p26": "超高中级的偶像",
    "p27": "你是一个能给人们带来欢笑的人！\n如果你决定成为职业偶像，一定会顺风顺水地获得发展哦！\n请让更多人看到你活力四射的演出吧！",
    "p28": "超高中级的军人",
    "p29": "想活着从在战场离开，需要一定的运气。\n比运气更重要的则是冷静。\n恰好你有出色的观察能力以及冷静的头脑，\n总能迅速识别并且解决危机。\n但是，请注意，最安全的地方往往是最危险的地方。",
    "p30": "超高中级的幸运",
    "p31": "你似乎没有特别之处。和绝大部分普通人一样普通地生活着。\n会悲伤，会喜悦，会恐惧，偶尔也会勇敢。\n也许普通地活着，度过每一天，就已经是最大的幸运了。",
    "p32": "超高中级的辣妹",
    "p33": "你是一位时髦达人！\n走在街上就会被过分瞩目，你的魅力没人会怀疑！\n说不定一不小心就会被邀请去知名的时装秀哦。",
    "p34": "超高中级的绝望",
    "p35": "去时装秀？别开玩笑了……\n你带给世界的可不是那么普通的东西啊。\n你的才能会让所有人陷入绝望，被绝望包围，最后被绝望吞噬。\n请绝望地享受绝望吧。"
  },
  "survey_profession": {
    "p2": "格斗家",
    "p3": "游泳选手",
    "p4": "飙车族",
    "p5": "棒球选手",
    "p6": "风纪委员",
    "p7": "程序员",
    "p8": "超高中级的",
    "p9": "同人作家",
    "p10": "文学少女",
    "p11": "赌徒",
    "p12": "名门公子",
    "p13": "占卜师",
    "p14": "偶像",
    "p15": "军人",
    "p16": "幸运",
    "p17": "辣妹",
    "p18": "绝望"
  },
  "sgtest_quest": {
    "p2": "具有极强引力的超高密度天体是什么？",
    "p3": "黑洞",
    "p4": "彗星",
    "p5": "巧克力",
    "p6": "玛雅人曾经预言哪一年会迎来世界末日？",
    "p7": "2012年",
    "p8": "2024年",
    "p9": "2000年",
    "p10": "智慧之人爱喝，且冈部伦太郎经常喝的饮料【Dr. P】是什么？",
    "p11": "加了致死量芥末的味噌汤",
    "p12": "味道独特的碳酸饮料",
    "p13": "喝了会产生困意的红茶",
    "p14": "以下哪种行为可以改变肚子里的婴儿性别？",
    "p15": "吃香蕉",
    "p16": "打麻将",
    "p17": "肚子里的婴儿性别无法改变",
    "p18": "在希腊字母表里，哪一个字母代表了开始？",
    "p19": "Ω",
    "p20": "α",
    "p21": "β",
    "p22": "因装上了柄而让现实剑斗游戏成为可能、并让血浆发光这样的划时代点子成为现实的未来装置的名字是？",
    "p23": "气体蛇",
    "p24": "光束剑",
    "p25": "比特粒子炮",
    "p26": "微小变化引起的极小事件，最终会导致未曾预料到的重大事件发生。这句话是对哪个名词的解释？",
    "p27": "蝴蝶效应",
    "p28": "蜜蜂效应",
    "p29": "独角兽效应",
    "p30": "大脑中有一个重要的部位对记忆起着关键作用。\n请问它因形状与哪种海洋生物相似而得名？",
    "p31": "刺豚",
    "p32": "翻车鱼",
    "p33": "海马",
    "p34": "相对论是由谁创立的？",
    "p35": "织田信长",
    "p36": "凤凰院凶真",
    "p37": "爱因斯坦",
    "p38": "北欧神话中司掌战争的女神叫什么？",
    "p39": "瓦尔基里",
    "p40": "伊邪那美",
    "p41": "宙斯",
    "p42": "Dmail可发送的数据量为36字节，相当于多少个全角字符？",
    "p43": "36",
    "p44": "12",
    "p45": "18",
    "p46": "从地球到银河系中心需要跨越多长的距离？",
    "p47": "384399km",
    "p48": "2.6万光年",
    "p49": "16.4光年",
    "p50": "夏季大三角中哪颗星星位于直角顶点，且与七夕神话紧密相连？",
    "p51": "织女星",
    "p52": "牵牛星",
    "p53": "天津四",
    "p54": "宇宙中含量最多的元素是什么？",
    "p55": "氢",
    "p56": "硫",
    "p57": "氧",
    "p58": "桐生萌郁有重度的手机依存症，时刻盯着手机屏幕且打字速度飞快。\n以下哪一个会是她的外号？",
    "p59": "闪光指压师",
    "p60": "电光石火之脑",
    "p61": "闪耀魔眼",
    "p62": "铃羽的骑行速度是20km/h，凶真的骑行速度是12km/h。\n他们从相距16km的AB两地同时相向而行，多久之后会相遇？",
    "p63": "1h",
    "p64": "30min",
    "p65": "40min",
    "p66": "在人气动画「雷NET翔」中登场的吉祥物角色叫什么名字？",
    "p67": "乌帕",
    "p68": "冈伦",
    "p69": "呱呱蛙",
    "p70": "以下哪个选项是冈部伦太郎在离别时使用的寒暄语？",
    "p71": "El Psy Kongroo",
    "p72": "El Psy Kongary",
    "p73": "El Psy Konkroo",
    "p74": "已知Labmem徽章的边缘刻有成员姓名的首字母，\n那么以下哪个选项是正确的排列顺序？",
    "p75": "OSHMKFUA",
    "p76": "OSHMKUFA",
    "p77": "OSHKMUFA",
    "p78": "于1975年发售、冈部伦太郎在秋叶原四处寻找的梦幻老式PC叫什么名字？",
    "p79": "IBN5100",
    "p80": "IBN5110",
    "p81": "IBM5100",
    "p82": "从2036年而来的时空旅行者是谁？",
    "p83": "约翰·提托",
    "p84": "鲁道夫·芬茨",
    "p85": "多拉·艾蒙",
    "p86": "在麻雀一番街段位战三麻规则中，出现哪种情况会途中流局？",
    "p87": "九种九牌",
    "p88": "四风连打",
    "p89": "三家立直",
    "p90": "在麻雀一番街段位战的规则中，如果想和绿一色，以下哪张牌是不需要的？",
    "p91": "7索",
    "p92": "8索",
    "p93": "发",
    "p94": "在麻雀一番街段位战的规则中，哪种牌型不属于役满？",
    "p95": "四暗刻",
    "p96": "九莲宝灯",
    "p97": "清一色"
  },
  "sgtest_bg": {
    "p2": "很遗憾，看样子命运并没有选中你……我等待着你再次挑战。",
    "p3": "你已经获得了LabMem的资格，但是，可别就此满足！真正的试炼现在才开始！",
    "p4": "被黑暗之力指引的人啊，聚集于此拥抱命运吧！",
    "p5": "从此刻起，你就是命运的共犯了！做好觉悟了吗？",
    "p6": "欢迎来到未来装置研究所！与我们一起行迹于黑暗中，揭开世界真理吧！",
    "p7": "希望你多学一点后再来挑战哦，真由氏也会为你加油的，好吗？",
    "p8": "太棒了！不过不过，好想看看你拿更高的分数啊。",
    "p9": "好厉害！真是令人吃惊呢。今后作为LabMem，我们一起加油吧！",
    "p10": "第一次看到这样的结果呢。欸嘿嘿、我可不能输给你呀。",
    "p11": "真由氏现在超级感动的！恭喜你！",
    "p12": "基础还是不够扎实。下次多做些准备再来挑战吧。",
    "p13": "嗯，算是合格了。不过不要满足，还有提升的空间。",
    "p14": "恭喜你。你的实力看来是无疑的。",
    "p15": "嗯，这个结果很不错呢。我觉得你可以对自己更有信心。",
    "p16": "取得100分的概率只有5%。你应该为自己感到骄傲。",
    "p17": "只要不放弃总会有办法的！下次加油吧！",
    "p18": "虽然合格了，但是战斗还远远没有结束呢！",
    "p19": "干得漂亮！让我见识到了你作为展示的实力哦。",
    "p20": "能拿到这么高的分数，我对你肃然起敬！",
    "p21": "好厉害！你已经和我一样，是一个独当一面的战士了！",
    "p30": "下载有礼",
    "p31": "LabMem相性测试",
    "p32": "我们未来装置研究所将在一番街设立临时支部。\n为了最终圣战，我们正在招募能与我们共同作战对抗机关的伙伴。\n符合条件者，由我，凤凰院凶真，亲自赐予你血之盟约。",
    "p33": "入选条件：",
    "p34": "相性测试分数    <span style=\"color: #3c3a43\">60</span>\n分以上。",
    "p35": "接受测试",
    "p36": "把纸扔了",
    "p37": "喂！难不成你想放过这个最佳机会吗？\n这可是能和狂气的疯狂科学家的我、凤凰院凶真能成为伙伴的机会啊！",
    "p38": "勉强试试",
    "p39": "活动已结束~\n将于3秒后自动跳转至【麻雀一番街】官网。",
    "p40": "名字",
    "p41": "开始测试",
    "p42": "下一步",
    "p43": "结束测试",
    "p44": "分数",
    "p45": "真可惜啊……下次加油吧！",
    "p46": "恭喜通过！LabMem",
    "p47": "重测",
    "p48": "保存结果",
    "p49": "分享结果",
    "p50": "奖励已发放，请队长在游戏内邮箱查看~",
    "p51": "下载游戏并分享可得限定牌背",
    "p52": "该昵称含有敏感词汇",
    "p53": "请输入8字符以内昵称（英语16字符）",
    "p54": "请输入昵称",
    "p55": "请输入8字符以内昵称",
    "p56": "请至少选择一个答案~",
    "p57": "保存成功",
    "p58": "一番街命运石之门联动",
    "p59": "麻雀一番街",
    "p60": "命运石之门",
    "p61": "【麻雀一番街×命运石之门联动】限时活动<LabMem相性测试>"
  }
}